export const BOOKING_WIZARD_ROUTE_PREFIX: string = '/dashboard/booking-wizard';

interface BookingWizardRoutes {
  index: {
    getUrl: () => string;
    path: string;
    relativePath: string;
  };
}

const bookingWizardRoutes: BookingWizardRoutes = {
  index: {
    path: BOOKING_WIZARD_ROUTE_PREFIX,
    getUrl: (): string => BOOKING_WIZARD_ROUTE_PREFIX,
    relativePath: 'booking-wizard'
  }
};

export default bookingWizardRoutes;
